export const generalEndpoints = {
  notifications: {
    count: {
      url: 'notifications/count',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
    markAsRead: {
      url: 'notifications/markRead',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
    get: {
      url: 'notifications/get',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  },
  files: {
    get: {
      url: 'files/entity/get',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
    create: {
      url: 'files/upload',
      version: 'v1',
      method: 'post',
      options: {
        headers: {},
      },
    },
  },
  challenges: {
    prizes: {
      get: {
        url: 'participants/rewards/get',
        version: 'v1',
        method: 'post',
        options: {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      },
      edit: {
        url: 'participants/rewards/edit',
        version: 'v1',
        method: 'post',
        options: {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      },
    },
    get: {
      url: 'challenges/get',
      version: 'v1',
      method: 'post',
      options: {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
    create: {
      url: 'challenges/create',
      version: 'v1',
      method: 'post',
      options: {
        headers: {},
      },
    },
    edit: {
      url: 'challenges/edit',
      version: 'v1',
      method: 'post',
      options: {
        headers: {},
      },
    },
    applications: {
      get: {
        url: 'applications/get',
        version: 'v1',
        method: 'post',
        options: {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      },
      create: {
        url: 'applications/create',
        version: 'v1',
        method: 'post',
        options: {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      },
      edit: {
        url: 'applications/edit',
        version: 'v1',
        method: 'post',
        options: {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      },
      evaluations: {
        get: {
          url: 'applications/evaluations/get',
          version: 'v1',
          method: 'post',
          options: {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        },
        // create: {
        //   url: 'applications/evaluations/create',
        //   version: 'v1',
        //   method: 'post',
        //   options: {
        //     headers: {
        //       'Content-Type': 'application/json',
        //     },
        //   },
        // },
        edit: {
          url: 'applications/evaluations/edit',
          version: 'v1',
          method: 'post',
          options: {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        },
        checkifiam: {
          url: 'applications/evaluations/checkifiam',
          version: 'v1',
          method: 'get',
          options: {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        },
      },
    },
  },
};
